import {
  FormControl,
  InputLabel,
  Select,
  SelectProps,
  styled,
} from "@mui/material";

interface GKSelectProps {
  inputLabel?: string;
  helperText?: string;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.grey[600],
  },
  "& .MuiInputLabel-shrink": {
    color: theme.palette.primary.main,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    fontSize: 14,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[300],
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
}));

function GKSelect(props: GKSelectProps & SelectProps) {
  const { inputLabel, children, size, ...rest } = props;

  return (
    <StyledFormControl fullWidth size={size}>
      <InputLabel>{inputLabel}</InputLabel>
      <Select {...rest} label={inputLabel} size={size}>
        {children}
      </Select>
    </StyledFormControl>
  );
}

export default GKSelect;
